"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowUtils = void 0;
const useWindowSize_1 = __importDefault(require("react-use/lib/useWindowSize"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
const useWindowUtils = () => {
    const { width } = (0, useWindowSize_1.default)();
    return {
        isMobileView: width <= mediaQuery_enum_1.MediaQuery.SMALL,
        isMediumView: width > mediaQuery_enum_1.MediaQuery.SMALL,
        isDesktopView: width > mediaQuery_enum_1.MediaQuery.MEDIUM,
    };
};
exports.useWindowUtils = useWindowUtils;
